/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from 'root-saga';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistStore,
} from 'redux-persist';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import storage from 'redux-persist/lib/storage';
import { mintNFTsSlice } from 'modules/mint-nfts/slice';
import { getNFTsSlice } from 'modules/home/slice';
import { purchaseNFTsSlice } from 'modules/artworks/slice';
import { getMyNFTsSlice } from 'modules/my-artworks/slice';
import { getAdminsSlice } from 'modules/admin/slice';
import { addAdminsSlice } from 'modules/add-admin/slice';

export const sagaMiddleware = createSagaMiddleware();
/**
 * White listed slices which needs to be persist with encryption
 */
const persistConfig = {
  //   version: ENVIRONMENT.PERSIST_VERSION,
  version: '',
  key: 'app',
  storage,
  stateReconciler: hardSet,
  blacklist: ['feature/mint-nfts', 'feature/get-admins'],
  writeFailHandler(error) {
    // logger.error(error);
    console.log(error);
  },
};
/**
 * Combine all the persist and non persist reducers
 */
const reducers = combineReducers({
  'feature/mint-nfts': mintNFTsSlice.reducer,
  'feature/get-nfts': getNFTsSlice.reducer,
  'feature/purchase-nfts': purchaseNFTsSlice.reducer,
  'feature/my-nfts': getMyNFTsSlice.reducer,
  'feature/get-admins': getAdminsSlice.reducer,
  'feature/add-admins': addAdminsSlice.reducer,
});
/**
 * Define what are the slice which needs to be persist
 */
const persistedReducer = persistReducer(persistConfig, reducers);
/**
 * Register all the slices into the main store with encryption
 */
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    sagaMiddleware,
    // customMiddleware,
  ],
});
sagaMiddleware.run(rootSaga);
persistStore(store);
//
export default store;
